module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_lg_02.3a54fbf7.jpg";